import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Testimonials.css';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Testimonials = () => {
  const navigate = useNavigate();

  const handleNavigateToRewards = () => {
    navigate('/digibeanapi');
  };
  return (
    <section className="testimonials-section" id="testimonials">
       
      <div className="container">
      <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <a href="#testimonials" className="section-link">Feature</a>
          <h2 className="news-title">What's in store</h2>
        </motion.div>
        <motion.div 
          className="testimonial-card"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="solutions-image">
            {/* This will be replaced with an actual image in production */}
          </div>
          <div className="testimonial-content">
            <div className="testimonial-header">
            <Button 
              sx={{
                backgroundColor: "#077336", 
                color: "white", 
                padding: "10px 20px", 
                borderRadius: "20px",
                fontSize: "16px", 
                cursor: "pointer",
                '&:hover': { backgroundColor: "#055824" }
              }}
              onClick={handleNavigateToRewards}
            >
              Try Rewards
            </Button>
            </div>
            <div className="testimonial-quote">
              
              <p className="quote-text">
                Integrate Koffieland's DigiBean API into your app and reward you customers.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;
